import React, { useState, useEffect } from 'react';
import './Dashboard.css';

function Dashboard() {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [refreshKey, setRefreshKey] = useState(0);

  useEffect(() => {
    fetchStats();
  }, [refreshKey]);

  const fetchStats = async () => {
    try {
      setLoading(true);
      const response = await fetch('/api/stats/overview');
      if (!response.ok) throw new Error('Failed to fetch stats');
      const data = await response.json();
      setStats(data);
      setError(null);
    } catch (err) {
      console.error('Error fetching stats:', err);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteStore = async (storeId, storeName) => {
    if (!window.confirm(`Möchten Sie den Händler "${storeName}" wirklich löschen?`)) {
      return;
    }

    try {
      const response = await fetch(`/api/stats/stores/${storeId}`, {
        method: 'DELETE'
      });
      if (!response.ok) throw new Error('Failed to delete store');
      
      setRefreshKey(prev => prev + 1);
      alert('Händler erfolgreich gelöscht');
    } catch (err) {
      console.error('Error deleting store:', err);
      alert('Fehler beim Löschen: ' + err.message);
    }
  };

  const handleEditStore = (storeId) => {
    // Für zukünftige Implementierung - Modal oder Seite zum Bearbeiten
    alert('Bearbeitungsfunktion wird noch implementiert');
  };

  const handleDeleteCategory = async (type, name) => {
    if (!window.confirm(`Möchten Sie die Kategorie "${name}" (${type}) wirklich löschen?`)) {
      return;
    }

    try {
      const response = await fetch(
        `/api/stats/categories/${encodeURIComponent(type)}/${encodeURIComponent(name)}`,
        { method: 'DELETE' }
      );
      if (!response.ok) throw new Error('Failed to delete category');
      
      setRefreshKey(prev => prev + 1);
      alert('Kategorie erfolgreich gelöscht');
    } catch (err) {
      console.error('Error deleting category:', err);
      alert('Fehler beim Löschen: ' + err.message);
    }
  };

  if (loading) return <div className="dashboard-loading">Lädt...</div>;
  if (error) return <div className="dashboard-error">Fehler: {error}</div>;
  if (!stats) return <div className="dashboard-error">Keine Daten verfügbar</div>;

  return (
    <div className="dashboard">
      <div className="dashboard-header">
        <h1>📊 Dashboard Übersicht</h1>
        <button onClick={() => setRefreshKey(prev => prev + 1)} className="refresh-btn">
          ↻ Aktualisieren
        </button>
      </div>

      {/* Summary Cards */}
      <div className="summary-cards">
        <div className="card">
          <div className="card-value">{stats.totals.storeCount}</div>
          <div className="card-label">Händler</div>
        </div>
        <div className="card">
          <div className="card-value">{stats.totals.categoryCount}</div>
          <div className="card-label">Kategorien</div>
        </div>
        <div className="card">
          <div className="card-value">{stats.totals.productCount}</div>
          <div className="card-label">Produkte</div>
        </div>
        <div className="card">
          <div className="card-value">{stats.totals.totalPrices}</div>
          <div className="card-label">Preise Online</div>
        </div>
      </div>

      {/* Stores Section */}
      <section className="dashboard-section">
        <h2>🏪 Händler Übersicht</h2>
        <div className="stores-list">
          {stats.stores.map(store => (
            <div key={store.id} className="store-row">
              <div className="store-content">
                <div className="store-name">
                  <a href={store.website || '#'} target={store.website ? "_blank" : undefined} rel={store.website ? "noopener noreferrer" : undefined}>
                    {store.name}
                  </a>
                </div>
                <div className="store-stats">
                  <span className="stat-item">📦 {store.productCount} Produkte</span>
                  <span className="stat-item">💰 {store.priceCount} Preise Online</span>
                </div>
              </div>
              <div className="store-actions">
                <button
                  onClick={() => handleEditStore(store.id)}
                  className="action-btn edit-btn"
                  title="Bearbeiten"
                >
                  ✏️
                </button>
                <button
                  onClick={() => handleDeleteStore(store.id, store.name)}
                  className="action-btn delete-btn"
                  title="Löschen"
                >
                  🗑️
                </button>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Categories Section */}
      <section className="dashboard-section">
        <h2>📂 Kategorien Übersicht</h2>
        <div className="table-container">
          <table className="dashboard-table">
            <thead>
              <tr>
                <th>Typ</th>
                <th>Name</th>
                <th>Produkte</th>
                <th>Preise Online</th>
                <th>Aktion</th>
              </tr>
            </thead>
            <tbody>
              {stats.categories.map((cat, idx) => (
                <tr key={idx}>
                  <td>{cat.type}</td>
                  <td>{cat.name}</td>
                  <td className="center">{cat.productCount}</td>
                  <td className="center">{cat.priceCount}</td>
                  <td className="center">
                    <button
                      onClick={() => handleEditStore(null)}
                      className="btn-edit"
                      title="Bearbeiten"
                    >
                      ✏️
                    </button>
                    <button
                      onClick={() => handleDeleteCategory(cat.type, cat.name)}
                      className="btn-delete"
                      title="Löschen"
                    >
                      🗑️
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </section>
    </div>
  );
}

export default Dashboard;
